export default "__VITE_ASSET__iBPutF5s__"